import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Widget.scss';

export default class Widget extends Component {
    render() {
        const { variant, left, right } = this.props;

        return (
            <div className={`widget-row ${variant}`}>
                <div className="widget-half left">
                    {left}
                </div>
                <div className="widget-half">
                    {right}
                </div>
            </div>
        );
    }
}

Widget.propTypes = {
    variant: PropTypes.oneOf([
        'dark',
        'light'
    ]),
    left: PropTypes.node,
    right: PropTypes.node
};

Widget.defaultProps = {
    variant: 'dark'
};